/**
 * 線画アイコン(2026-09-10 指示: システム内のアイコンは線画アイコンに統一)。
 * 絵文字・記号(📅 ☰ ▶ ◀ ✕ ⠿ ▲ ▼ ⇅ ▾)の置き換え用。
 * 色は currentColor、大きさは size(既定16px)。装飾なので aria-hidden(意味はボタンの aria-label 側に持たせる)。
 */
import type { ReactNode, SVGProps } from 'react';

type IconProps = { size?: number } & Omit<SVGProps<SVGSVGElement>, 'width' | 'height' | 'viewBox' | 'children'>;

function Svg({ size = 16, className, children, ...rest }: IconProps & { children: ReactNode }) {
  return (
    <svg
      className={className ? `ico ${className}` : 'ico'}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.8}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
      {...rest}
    >
      {children}
    </svg>
  );
}

export const IconCalendar = (p: IconProps) => (
  <Svg {...p}>
    <rect x="3" y="5" width="18" height="16" rx="2" />
    <path d="M3 10h18M8 3v4M16 3v4" />
  </Svg>
);

export const IconChevronLeft = (p: IconProps) => (
  <Svg {...p}>
    <path d="M15 5l-7 7 7 7" />
  </Svg>
);

export const IconChevronRight = (p: IconProps) => (
  <Svg {...p}>
    <path d="M9 5l7 7-7 7" />
  </Svg>
);

export const IconChevronDown = (p: IconProps) => (
  <Svg {...p}>
    <path d="M5 9l7 7 7-7" />
  </Svg>
);

export const IconMenu = (p: IconProps) => (
  <Svg {...p}>
    <path d="M4 7h16M4 12h16M4 17h16" />
  </Svg>
);

export const IconClose = (p: IconProps) => (
  <Svg {...p}>
    <path d="M6 6l12 12M18 6L6 18" />
  </Svg>
);

/** ドラッグでつかむ印(並べ替え) */
export const IconGrip = (p: IconProps) => (
  <Svg {...p}>
    <path d="M8 7h8M8 12h8M8 17h8" />
  </Svg>
);

/** 並べ替え: 未指定(上下) */
export const IconSort = (p: IconProps) => (
  <Svg {...p}>
    <path d="M8 9l3-3 3 3M8 15l3 3 3-3" />
  </Svg>
);

/** 並べ替え: 昇順 */
export const IconSortAsc = (p: IconProps) => (
  <Svg {...p}>
    <path d="M6 15l6-6 6 6" />
  </Svg>
);

/** 並べ替え: 降順 */
export const IconSortDesc = (p: IconProps) => (
  <Svg {...p}>
    <path d="M6 9l6 6 6-6" />
  </Svg>
);
